import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-border bg-background mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-xl font-bold tracking-tighter text-foreground mb-3">
              LIRK<span className="text-foreground/30 font-light"> PRINT</span>
            </h3>
            <p className="text-sm text-foreground/50 font-mono leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          {/* Links */}
          <div>
            <p className="text-[10px] font-mono tracking-widest uppercase text-foreground/30 mb-4">{t("footer.links")}</p>
            <div className="space-y-2">
              {[
                { to: "/", label: t("nav.showroom") },
                { to: "/shop", label: t("nav.shop") },
                { to: "/about", label: t("nav.about") },
                { to: "/contact", label: t("nav.contact") },
              ].map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="flex items-center gap-1 text-sm text-foreground/50 hover:text-foreground transition-colors group"
                >
                  {link.label}
                  <ArrowUpRight size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </Link>
              ))}
            </div>
          </div>

          {/* Connect */}
          <div>
            <p className="text-[10px] font-mono tracking-widest uppercase text-foreground/30 mb-4">{t("footer.connect")}</p>
            <div className="space-y-3">
              <a href="mailto:hello@lirkprint.com" className="flex items-center gap-3 text-sm text-foreground/50 hover:text-foreground transition-colors group">
                <Mail size={14} strokeWidth={1.5} />
                hello@lirkprint.com
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-sm text-foreground/50 hover:text-foreground transition-colors group">
                <Instagram size={14} strokeWidth={1.5} />
                @lirkprint
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mt-12 pt-8 border-t border-border">
          <p className="text-xs text-foreground/30 font-mono">
            © {new Date().getFullYear()} Lirk Print. {t("footer.rights")}.
          </p>
          <p className="text-xs text-foreground/20 font-mono tracking-widest uppercase">
            3D PRINTED IN GERMANY
          </p>
        </div>
      </div>
    </footer>
  );
}
